<template>
    <div>
        <DRow>
            <DCol>
                <DTabs class="mb-3">
                    <DTabItem
                        id="sepa-retry-tab-failure-codes"
                        :label="__('settings.sepa_retry.tabs.failure_codes')"
                        :route-url="$route('settings.sepa-retry-failure-codes.index')"
                        :active="true"
                    />
                    <DTabItem
                        id="sepa-retry-tab-retry-settings"
                        :label="__('settings.sepa_retry.tabs.retry_settings')"
                        :route-url="$route('settings.manage-sepa-retry.create')"
                        :active="false"
                    />
                </DTabs>
            </DCol>
        </DRow>

        <DCard
            :title="__('settings.sepa_retry.tabs.failure_codes')"
            padding
        >
            <DTable
                :items="failureCodes.data"
                :fields="[
                    { key: 'id', label: __('settings.sepa_retry_failure_codes.form.id'), sorter: false },
                    { key: 'code', label: __('settings.sepa_retry_failure_codes.form.code'), sorter: false },
                    { key: 'description', label: __('settings.sepa_retry_failure_codes.form.description'), sorter: false },
                    { key: 'actions', label: '', sorter: false, filter: false },
                ]"
                hover
                sorter
            >
                <template #actions="{ item }">
                    <td>
                        <div style="display: flex; grid-gap: 10px;">
                            <DButton
                                :id="`edit_${item.id}`"
                                icon="pencil"
                                mini
                                @click="openEditModal(item)"
                            />
                            <DButton
                                :id="`btn-delete-${item.id}`"
                                icon="trash-can-outline"
                                color="danger"
                                mini
                                @click="confirmDelete(item.id)"
                            />
                        </div>
                    </td>
                </template>
            </DTable>

            <DPagination
                v-if="failureCodes.last_page > 1"
                :active-page="failureCodes.current_page"
                :pages="failureCodes.last_page"
                align="center"
                @update:activePage="changePage"
            />

            <DFabs>
                <DFab
                    id="btn-add"
                    icon="plus"
                    :label="__('settings.sepa_retry_failure_codes.add_button')"
                    @click="openCreateModal"
                />
            </DFabs>
        </DCard>

        <FailureCodeModal
            v-if="showFormModal"
            :failure-code="selectedFailureCode"
            :is-create="isCreate"
            @closeModal="closeFormModal"
        />

        <DModal
            v-model:show="showDeleteConfirm"
            :title="__('settings.sepa_retry_failure_codes.delete_confirm_modal.title')"
            :message="__('settings.sepa_retry_failure_codes.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showDeleteConfirm = false"
            @confirm="deleteFailureCode"
        />
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import FailureCodeModal from '~@/Components/Settings/SepaRetryFailureCodes/FailureCodeModal.vue'

defineProps({
    failureCodes: {
        type: Object,
        default () {
            return {}
        }
    }
})

const showFormModal = ref(false)
const showDeleteConfirm = ref(false)
const selectedFailureCode = ref(null)
const selectedId = ref(null)
const isCreate = ref(true)

function openCreateModal () {
    selectedFailureCode.value = null
    isCreate.value = true
    showFormModal.value = true
}

function openEditModal (item) {
    selectedFailureCode.value = item
    isCreate.value = false
    showFormModal.value = true
}

function closeFormModal () {
    showFormModal.value = false
    selectedFailureCode.value = null
}

function confirmDelete (id) {
    selectedId.value = id
    showDeleteConfirm.value = true
}

function deleteFailureCode () {
    router.delete(route('settings.sepa-retry-failure-codes.destroy', { sepaRetryFailureCode: selectedId.value }), {
        preserveScroll: true,
    })
    showDeleteConfirm.value = false
}

function changePage (page) {
    const queryParameters = {}

    if (page > 1) {
        queryParameters.page = page
    }

    router.get(route('settings.sepa-retry-failure-codes.index'), queryParameters)
}
</script>
